import React from 'react';
import image from '../../Images/my pic.png';
import './About.css';

const About = () => {
    return (
        <div id='about' className="container control">
            <h1  style={{textAlign:"center"}}><span><u>ABOUT ME</u></span></h1>
            <div className="row">
                <div className="col-md-6 col-sm-12 col-12">
                    <div className="image pl-5 pic2">
                        <img  className="img-fluid img-thumbnail" src={image} alt="wait" />
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 col-12">
                    <div className="about-details1">
                        <p>
                            Hello! I'm Sudipta Acharjee, a passionate MERN Stack Developer. I develop web applications. My core skill is based on JavaScript and I love to do most of the things using JavaScript. I love to make the web more open to the world. I am available for any kind of job opportunity that suits my interests.
                        </p>
                        <div className="action mt-5">
                            <a className='btn' href="https://drive.google.com/uc?export=download&amp;id=1f-BVDra22R71qkpNJQzkSfrDZsk6BrvW" target="_blank">Get Resume</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;